<template>
  <form @submit.prevent="$emit('submit')" class="basic-information col mt-lg-0">
    <div class="mb-5">
      <step-title
        title="Informações básicas"
        description="Através dessas informações seu cliente vai identificar o seu produto."
      />
    </div>

    <div class="row mt-6">
      <div class="col-lg-12">
        <bp-input
          v-model="form.name"
          required
          class="mb-6"
          label="Nome do curso"
          placeholder="Prefira um nome que chame a atenção do público"
          description="Atenção! Este é o nome que exibiremos para os seus compradores."
          :limit="64"
          size="xl"
        />
        <bp-input
          v-model="form.description"
          :rows="4"
          textarea
          required
          class="mb-6"
          label="Descrição (SEO)"
          placeholder="Explique de forma breve do que se trata o seu produto."
          description="Essa descrição nos ajudará na análise do seu produto."
          :limit="980"
          size="xl"
        />
        <bp-select
          class="mt-2"
          v-model="form.category_id"
          id="category"
          label="Categoria do produto"
          placeholder="Selecionar uma categoria..."
          select
          :options="categories"
          :errors="errors.category_id"
          :disabled="!categories.length"
          required
          size="xl"
        />

        <span class="small-text text-secondary">
          Escolha a categoria adequada para que seus compradores encontrem seu
          produto mais facilmente.
        </span>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    form: {
      type: Object,
      default: null
    },
    product: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: null
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uploadError: null,
      currentStatus: null,
      uploadFieldName: "photo"
    };
  },
  mounted() {
    this.$store.dispatch("product/getCategories").then();
  },
  watch: {
    form(val) {
      if (val.category) {
        this.form.category_id = val.category.id;
      }
    }
  },
  computed: {
    ...mapState("product", ["categories"]),
    isValid() {
      return (
        this.form.name &&
        this.form.name.length <= 64 &&
        this.form.description &&
        this.form.description.length <= 980 &&
        this.form.category_id
      );
    }
  }
};
</script>
